/* eslint-disable @typescript-eslint/no-non-null-assertion */
'use client';

import { createTheme } from '@mui/material';

import { alpha } from '../../../utils';
import { Theme } from '../../types';
import { landingBaseTheme } from '../base';

export const landingDarkTheme = createTheme({
  ...landingBaseTheme,
  palette: {
    ...landingBaseTheme.palette,
    get surface1() {
      return this.black[900];
    },
    get surface2() {
      return this.black['900_a'] as string;
    },
    get surface3() {
      return this.black['900_b'] as string;
    },
    get surface4() {
      return this.black[800];
    },

    get text1() {
      return this.black[100];
    },
    get text2() {
      return this.black[500];
    },
    get text3() {
      return this.black[600];
    },
    get text4() {
      return this.black[300];
    },

    get text() {
      return { primary: this.text2 };
    },

    get textWhite() {
      return this.grey![100]!;
    },
    get textBlack() {
      return alpha(this.black[900], 0.85);
    },
    get textInvert() {
      return alpha(this.black[900], 0.9);
    },

    get inputNormal() {
      return this.black['800_a'] as string;
    },
    get inputHover() {
      return this.black['700_a'] as string;
    },
    get inputActive() {
      return landingBaseTheme.palette.primary.light;
    },
    get inputDisabled() {
      return alpha(this.black['700_b'] as string, 0.5);
    },

    get alertSuccess() {
      return this.black['900_b'] as string;
    },
    get alertInfo() {
      return this.black['900_b'] as string;
    },
    get alertError() {
      return this.black['900_b'] as string;
    },
    get alertWarning() {
      return this.black['900_b'] as string;
    },

    get dropdownMenu() {
      return this.black['900_a'] as string;
    },
    get tooltipFill() {
      return this.black['900_b'] as string;
    },
    get chip() {
      return '#080F22';
    },

    get divider() {
      return this.grey?.['800'];
    },

    get background() {
      return { paper: this.surface1 };
    },

    get walletGradient() {
      return `linear-gradient(180deg, ${alpha(
        this.blue[700],
        0.28,
      )} 0%, ${alpha(this.blue[700], 0.69)} 100%)`;
    },

    mode: 'dark',
  },
}) as Theme;
